// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"01c2fbdd","217":"1cbcb794","501":"599f116a","937":"acf5592e"}[chunkId] + ".chunk.js";
};